var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.02182 25.0189C12.35 32.695 18.4317 37.4343 21.6055 35.6045C24.7794 33.7747 23.8436 26.0686 19.5154 18.3924C15.1871 10.7163 9.10556 5.97694 5.93171 7.80676C2.75785 9.63658 3.69364 17.3427 8.02182 25.0189Z",
    fill: "#FBCDD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0498 35.9986C23.7033 35.9986 26.6651 28.8355 26.6651 19.9993C26.6651 11.1631 23.7033 4 20.0498 4C16.3963 4 13.4346 11.1631 13.4346 19.9993C13.4346 28.8355 16.3963 35.9986 20.0498 35.9986Z",
    fill: "#DC7296"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0779 25.0189C27.7497 32.695 21.6681 37.4343 18.4942 35.6045C15.3203 33.7746 16.2561 26.0685 20.5844 18.3924C24.9126 10.7162 30.9942 5.97694 34.168 7.80676C37.3419 9.63658 36.4061 17.3427 32.0779 25.0189Z",
    fill: "#FBCDD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M22.2813 35.0643C24.6099 32.5574 23.5013 25.4629 19.5153 18.3937C17.9777 15.6668 16.2188 13.3111 14.4477 11.4883C13.8061 13.9534 13.4346 16.8711 13.4346 19.9992C13.4346 28.7977 16.3712 35.9363 20.0033 35.997C20.0265 35.9973 20.0499 35.9978 20.073 35.9977C20.8478 35.9913 21.591 35.6624 22.2813 35.0643Z",
    fill: "#F2EFF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 36.0003C22.0596 36.0003 23.7487 34.4637 23.9489 32.4417C24.1898 30.0079 23.3882 27.4887 21.5445 25.6244L20.7463 24.8173C20.3618 24.4281 19.7381 24.4281 19.3537 24.8173L18.5555 25.6244C16.7118 27.4887 15.9102 30.008 16.1511 32.4417C16.3513 34.4637 18.0404 36.0003 20.05 36.0003Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0495 33.9063C21.416 33.9063 22.5238 32.7861 22.5238 31.4043C22.5238 30.0225 21.416 28.9023 20.0495 28.9023C18.683 28.9023 17.5752 30.0225 17.5752 31.4043C17.5752 32.7861 18.683 33.9063 20.0495 33.9063Z",
    fill: "#DC7296"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeFive);
export default __webpack_public_path__ + "static/media/shape-five.95dc5cc365acb8e17cc494a6b1a9d078.svg";
export { ForwardRef as ReactComponent };